import { useQuery } from '@tanstack/react-query';
import { getCacheTime } from '@/feature/query/time';
import { fetchSignalMetadata } from './api';

export const useSignalMetadataQuery = (equipmentId: string | undefined) =>
  useQuery({
    queryKey: ['signalMetadata', equipmentId],
    queryFn: () => fetchSignalMetadata(equipmentId!),
    enabled: Boolean(equipmentId),
    ...getCacheTime('long'),
  });
